.tooltip {
  fill: #555555;
  margin-left: 5px;
  position: relative;
  top: -2px;
}
